const artistsHR = {
    "view": {
        "table": {
            "title": "Popis vaših izvođača",
            "column": {
                "name": "Ime izvođača",
                "owner": "Vlasnik",
                "spotify_link": "Spotify poveznica",
                "apple_music_link": "Apple Music poveznica",
                "amazon_music_link": "Amazon Music poveznica",
                "deezer_link": "Deezer poveznica",
                "flagged": "Označeno",
                "blacklisted": "Na crnoj listi",
                "action": "Akcija"
            },
            "button": {
                "export_csv": "Izvoz CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "message": {
                "artistFlagged": "Ovaj izvođač je označen i potrebna je escrow uplata za distribuciju izdanja na Spotify.",
                "artistNotFlagged": "Ovaj izvođač je podoban za distribuciju na Spotify.",
                "artistBlacklisted": "Ovaj izvođač je na crnoj listi i nepodoban za distribuciju.",
                "artistNotBlacklisted": "Ovaj izvođač nije na crnoj listi i podoban za distribuciju.",
            }
        },
        "message": {
            "success": "Izvođač je uklonjen!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovo!",
            "notSubscribed": "Niste pretplaćeni na nijedan plan, stoga možete dodati samo <strong>3 izvođača</strong>. Molimo <3>pretplatite se</3> na plan kako biste imali neograničen broj izvođača.",
            "subscriptionUpgrade": "Vaš trenutni pretplatnički plan ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj pretplatnički plan kako biste koristili ovu značajku.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>nastavite</1> svoju pretplatu kako biste koristili ovu značajku.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte podršku za više informacija."
        },
        "modal": {
            "cantBeDeleted": {
                "header": "Izvođač {{artistName}} ne može biti izbrisan",
                "body": "Izvođač {{artistName}} ne može biti izbrisan jer već ima pridružene pjesme/izdanja."
            },
            "delete": {
                "header": "Izbrisati {{artistName}}?",
                "body": "Jeste li sigurni da zaista želite izbrisati ovog izvođača? Ova akcija može odvojiti vašeg izvođača od dodijeljenog izdanja."
            },
            "edit": {
                "header": "Urediti {{artistName}}?",
                "body": "Jeste li sigurni da želite promijeniti ime vašeg izvođača? Ovo bi moglo utjecati na metapodatke izdanja."
            }
        }
    },
    "add": {
        "title": "Dodaj izvođača",
        "form": {
            "label": {
                "is_new_artist": "Je li novi izvođač",
                "spotify_profile": "Spotify profil",
                "deezer_profile": "Deezer profil",
                "amazon_music_profile": "Amazon Music profil",
                "spotify_image": "Spotify slika",
                "deezer_image": "Deezer slika",
                "amazon_music_image": "Amazon Music slika",
                "spotify_id": "Spotify ID",
                "deezer_id": "Deezer ID",
                "amazon_music_id": "Amazon Music ID",
                "apple_id": "Apple ID",
                "name": "Ime",
                "name_preference": "Preferirano ime",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "subuser": "Pod-korisnik"
            },
            "help_text": {
                "is_new_artist": "Dodajete li novog izvođača, tj. ako vaš izvođač ima izdanja na Spotify/Deezer/Amazon Music/Apple Music, odaberite Ne, inače odaberite Da.",
                "spotify_profile": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača koji je već na Spotifyju, inače kliknite na gumb Nije pronađeno.",
                "deezer_profile": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača koji je već na Deezeru, inače kliknite na gumb Nije pronađeno.",
                "amazon_music_profile": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača koji je već na Amazon Musicu, inače kliknite na gumb Nije pronađeno.",
                "apple_id": "Napomena: Koristite ovo polje samo ako želite dodati izvođača koji je već na Apple Musicu, inače kliknite na gumb Nije pronađeno.",
                "subuser": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača za bilo kojeg od vaših pod-korisnika, inače ostavite neodabrano."
            },
            "placeholder": {
                "subuser": "Odaberite pod-korisnika...",
                "spotify_profile": "Unesite ime izvođača npr. The Weekend ili Spotify ID izvođača npr. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Unesite ime izvođača npr. The Weekend ili Deezer ID izvođača npr. 1406580",
                "amazon_music_profile": "Unesite ime izvođača npr. The Weekend ili Amazon ASIN izvođača npr. B005GI0T2U",
                "apple_id": "Unesite valjani Apple ID. Primjer: 635806095"
            },
            "button": {
                "reset": "Poništi",
                "not_found": "Nije pronađeno",
                "submit": "Pošalji"
            },
            "option": {
                "yes": "Da",
                "no": "Ne"
            },
            "validation": {
                "name_required": "Ime je obavezno",
                "name_invalid": "Ime izvođača mora sadržavati 'DJ' samo velikim slovima",
                "email_required": "Email je obavezan",
                "email_invalid": "Unesite valjani email",
                "name_duplicate": "Izvođač već postoji",
                "name_mismatch": "Ime izvođača mora biti isto za sve trgovine",
                "spotify_id_invalid": "Dodajte valjani Spotify ID. Primjer: 6eUKZXaKkcviH0Ku9w2n3B. Provjerite naš Centar za pomoć za više informacija.",
                "apple_id_required": "Apple ID je obavezan",
                "apple_id_invalid": "Dodajte valjani Apple ID. Primjer: 635806095. Provjerite naš Centar za pomoć za više informacija."
            }
        },
        "modal": {
            "title": {
                "new_artist_declaration": "Izjava o novom izvođaču",
                "profile_not_present_declaration": "Izjava o nepostojanju profila"
            },
            "body": {
                "profile_not_present_declaration": "Potvrđujem da profil ovog izvođača nije prisutan na <strong>{{store}}</strong> i da se profil ovog izvođača stvara svježe na <strong>{{store}}</strong>.",
                "new_artist_declaration": "Potvrđujem da profil ovog izvođača nije prisutan ni u jednoj od sljedećih trgovina i da se profil ovog izvođača stvara svježe u tim trgovinama.",
                "new_artist_declaration_amazon_music": "Amazon Music",
                "new_artist_declaration_apple_music": "Apple Music",
                "new_artist_declaration_deezer": "Deezer",
                "new_artist_declaration_spotify": "Spotify"
            },
            "button": {
                "confirm": "Potvrdi",
                "cancel": "Otkaži"
            }
        },
        "message": {
            "success": "Izvođač je dodan!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovo!",
            "errorBlacklisted": "Jedna ili više detalja koje ste pružili su povezani s izvođačem koji je na crnoj listi. Ako ste sigurni da je izvođač nije na crnoj listi, molimo kontaktirajte tim podrške za više informacija."
        }
    },
    "update": {
        "title": "Uredi izvođača",
        "form": {
            "label": {
                "spotify_profile": "Spotify profil",
                "deezer_profile": "Deezer profil",
                "amazon_music_profile": "Amazon Music profil",
                "spotify_image": "Spotify slika",
                "deezer_image": "Deezer slika",
                "amazon_music_image": "Amazon Music slika",
                "spotify_id": "Spotify ID",
                "deezer_id": "Deezer ID",
                "amazon_music_id": "Amazon Music ID",
                "apple_id": "Apple ID",
                "name": "Ime",
                "name_preference": "Preferirano ime",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "flagged": "Označeno"
            },
            "help_text": {
                "spotify_profile": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača koji je već na Spotifyju, inače kliknite na gumb Nije pronađeno.",
                "deezer_profile": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača koji je već na Deezeru, inače kliknite na gumb Nije pronađeno.",
                "amazon_music_profile": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača koji je već na Amazon Musicu, inače kliknite na gumb Nije pronađeno.",
                "apple_id": "Napomena: Koristite ovo polje samo ako želite dodati izvođača koji je već na Apple Musicu, inače kliknite na gumb Nije pronađeno."
            },
            "placeholder": {
                "spotify_profile": "Unesite ime izvođača npr. The Weekend ili Spotify ID izvođača npr. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Unesite ime izvođača npr. The Weekend ili Deezer ID izvođača npr. 1406580",
                "amazon_music_profile": "Unesite ime izvođača npr. The Weekend ili Amazon ASIN izvođača npr. B005GI0T2U",
                "apple_id": "Unesite valjani Apple ID. Primjer: 635806095"
            },
            "button": {
                "reset": "Poništi",
                "not_found": "Nije pronađeno",
                "submit": "Pošalji"
            },
            "validation": {
                "name_required": "Ime je obavezno",
                "email_required": "Email je obavezan",
                "email_invalid": "Unesite valjani email",
                "name_duplicate": "Izvođač već postoji",
                "name_mismatch": "Ime izvođača mora biti isto za sve trgovine",
                "name_mismatch_spotify": "Ime Spotify profila mora odgovarati imenu izvođača",
                "name_mismatch_deezer": "Ime Deezer profila mora odgovarati imenu izvođača",
                "name_mismatch_amazon_music": "Ime Amazon profila mora odgovarati imenu izvođača",
                "spotify_id_invalid": "Dodajte valjani Spotify ID. Primjer: 6eUKZXaKkcviH0Ku9w2n3B. Provjerite naš Centar za pomoć za više informacija.",
                "apple_id_required": "Apple ID je obavezan",
                "apple_id_invalid": "Dodajte valjani Apple ID. Primjer: 635806095. Provjerite naš Centar za pomoć za više informacija."
            }
        },
        "modal": {
            "title": {
                "profile_reset_declaration": "Izjava o resetiranju profila",
                "profile_not_present_declaration": "Izjava o nepostojanju profila"
            },
            "body": {
                "profile_not_present_declaration": "Potvrđujem da profil ovog izvođača nije prisutan na <strong>{{store}}</strong> i da se profil ovog izvođača stvara svježe na <strong>{{store}}</strong>.",
                "profile_reset_declaration": "Svjestan sam da će resetiranjem profila ovog izvođača na <strong>{{store}}</strong> ukloniti <strong>{{store}} ID</strong> iz cijelog sustava i da će to vjerojatno izazvati poremećaje u trgovinama i neslaganja izvođača."
            },
            "button": {
                "confirm": "Potvrdi",
                "cancel": "Otkaži"
            }
        },
        "message": {
            "success": "Izvođač imena '{{artistName}}' je ažuriran!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovo!",
            "errorBlacklisted": "Jedna ili više detalja koje ste pružili su povezani s izvođačem koji je na crnoj listi. Ako ste sigurni da je izvođač nije na crnoj listi, molimo kontaktirajte tim podrške za više informacija."
        }
    },
    "add_from_wishlist": {
        "title": "Dodaj izvođača",
        "form": {
            "label": {
                "spotify_profile": "Spotify profil",
                "deezer_profile": "Deezer profil",
                "amazon_music_profile": "Amazon Music profil",
                "spotify_id": "Spotify ID",
                "spotify_image": "Spotify slika",
                "deezer_id": "Deezer ID",
                "deezer_image": "Deezer slika",
                "amazon_music_id": "Amazon ID",
                "amazon_music_image": "Amazon Music slika",
                "apple_id": "Apple ID",
                "apple_image": "Apple slika",
                "name": "Ime",
                "name_preference": "Preferirano ime",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "subuser": "Pod-korisnik"
            },
            "placeholder": {
                "spotify_profile": "Unesite ime izvođača npr. The Weekend ili Spotify ID izvođača npr. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Unesite ime izvođača npr. The Weekend ili Deezer ID izvođača npr. 1406580",
                "amazon_music_profile": "Unesite ime izvođača npr. The Weekend ili Amazon ASIN izvođača npr. B005GI0T2U",
                "apple_id": "Unesite valjani Apple ID. Primjer: 635806095",
                "subuser": "Odaberite pod-korisnika..."
            },
            "help_text": {
                "spotify_profile": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača koji je već na Spotifyju, inače kliknite na gumb Nije pronađeno.",
                "deezer_profile": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača koji je već na Deezeru, inače kliknite na gumb Nije pronađeno.",
                "amazon_music_profile": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača koji je već na Amazon Musicu, inače kliknite na gumb Nije pronađeno.",
                "apple_id": "Napomena: Koristite ovo polje samo ako želite dodati izvođača koji je već na Apple Musicu, inače kliknite na gumb Nije pronađeno.",
                "subuser": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izvođača za bilo kojeg od vaših pod-korisnika, inače ostavite neodabrano."
            },
            "button": {
                "reset": "Poništi",
                "notFound": "Nije pronađeno?",
                "submit": "Pošalji",
                "cancel": "Otkaži",
                "confirm": "Potvrdi"
            },
            "validation": {
                "name_required": "Ime je obavezno",
                "email_required": "Email je obavezan",
                "email_invalid": "Unesite valjani email",
                "spotify_id_invalid": "Dodajte valjani Spotify ID. Primjer: 6eUKZXaKkcviH0Ku9w2n3B. Provjerite naš Centar za pomoć za više informacija.",
                "apple_id_required": "Apple ID je obavezan",
                "apple_id_invalid": "Dodajte valjani Apple ID. Primjer: 635806095. Provjerite naš Centar za pomoć za više informacija."
            },
            "message": {
                "errorArtistExists": "Izvođač već postoji",
                "errorNameMismatch": "Ime izvođača mora biti isto za sve trgovine",
                "errorSpotifyNameMismatch": "Ime Spotify profila mora odgovarati imenu izvođača",
                "errorDeezerNameMismatch": "Ime Deezer profila mora odgovarati imenu izvođača",
                "errorAmazonNameMismatch": "Ime Amazon profila mora odgovarati imenu izvođača"
            }
        },
        "message": {
            "success": "Izvođač je dodan!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovo!",
            "errorBlacklisted": "Jedna ili više detalja koje ste pružili su povezani s izvođačem koji je na crnoj listi. Ako ste sigurni da je izvođač nije na crnoj listi, molimo kontaktirajte tim podrške za više informacija."
        },
        "modal": {
            "profileMissing": {
                "header": "Izjava o nepostojanju profila",
                "body": "Potvrđujem da profil ovog izvođača nije prisutan na <strong>{{storeName}}</strong> i da se profil ovog izvođača stvara svježe na <strong>{{storeName}}</strong>.",
                "button": {
                    "cancel": "Otkaži",
                    "confirm": "Potvrdi"
                }
            }
        }
    },
    "viewDetails": {
        "view": {
            "label": {
                "followers": "SLJEDBENICI",
                "popularity": "POPULARNOST",
                "genres": "ŽANROVI",
                "flagged": "OZNAČENO",
                "notAvailable": "Nije dostupno",
                "notAvailableAbbr": "N/D"
            },
            "similarArtists": {
                "title": "Slični izvođači",
                "table": {
                    "column": {
                        "artist": "Izvođač",
                        "followers": "Sljedbenici",
                        "popularity_pct": "Popularnost (%)",
                        "genres": "Žanrovi",
                        "wishlist": "Lista želja"
                    }
                },
                "label": {
                    "notAvailable": "Nije dostupno",
                    "notAvailableAbbr": "N/D"
                },
                "message": {
                    "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovo!"
                },
                "modal": {
                    "addToWishlist": {
                        "header": "Dodaj izvođača {{artistName}} na listu želja",
                        "body": "Jeste li sigurni da želite dodati izvođača {{artistName}} na svoju listu želja?",
                        "message": {
                            "success": "Izvođač dodan na listu želja!"
                        }
                    },
                    "removeFromWishlist": {
                        "header": "Ukloni izvođača {{artistName}} s liste želja",
                        "body": "Jeste li sigurni da želite ukloniti izvođača {{artistName}} s liste želja?"
                    }
                }
            },
            "topTracks": {
                "title": "Najbolje pjesme",
                "table": {
                    "column": {
                        "track": "Pjesma",
                        "release": "Izdanje",
                        "artists": "Izvođač(i)",
                        "popularity_pct": "Popularnost (%)",
                        "preview": "Pregled"
                    }
                },
                "label": {
                    "audioElementNotSupported": "Vaš preglednik ne podržava audio element."
                }
            }
        }
    }
};

export default artistsHR;